(function () {
  'use strict';

  angular
    .module('dashboard.employee.sales')
    .controller('dashboardEmployeeSalesCtrl', dashboardEmployeeSalesCtrl);

  dashboardEmployeeSalesCtrl.$inject = [
    'DashboardEmployeeSales',
    '$translate',
    '$rootScope',
    '$scope',
    'datamatic',
    '$mdToast',
    'moment',
  ];

  function dashboardEmployeeSalesCtrl(
    DashboardEmployeeSales,
    $translate,
    $rootScope,
    $scope,
    datamatic,
    /** @type {angular.material.IToastService} */ $mdToast,
    moment,
  ) {
    var vm = this;

    vm.lastUpdatedAt = moment().format();
    vm.years = getYears();
    vm.year = vm.years[vm.years.length - 1];
    vm.noData = true;
    vm.chartData = [];
    vm.metric = 'value';

    var requestInProgress = false;

    var textMonths = [
      $translate.instant('general.month.january'),
      $translate.instant('general.month.february'),
      $translate.instant('general.month.march'),
      $translate.instant('general.month.april'),
      $translate.instant('general.month.may'),
      $translate.instant('general.month.june'),
      $translate.instant('general.month.july'),
      $translate.instant('general.month.august'),
      $translate.instant('general.month.september'),
      $translate.instant('general.month.october'),
      $translate.instant('general.month.november'),
      $translate.instant('general.month.december'),
    ];

    var textNoData = $translate.instant('reports.page.byprojects.nodata');
    var textValue = $translate.instant('reports.page.sales.by.time.income');
    var textCount = $translate.instant('reports.page.sales.by.time.count');
    var textSqm = $translate.instant('reports.page.sales.by.time.sqm');
    $rootScope.$on('$translateChangeSuccess', function () {
      textMonths = [
        $translate.instant('general.month.january'),
        $translate.instant('general.month.february'),
        $translate.instant('general.month.march'),
        $translate.instant('general.month.april'),
        $translate.instant('general.month.may'),
        $translate.instant('general.month.june'),
        $translate.instant('general.month.july'),
        $translate.instant('general.month.august'),
        $translate.instant('general.month.september'),
        $translate.instant('general.month.october'),
        $translate.instant('general.month.november'),
        $translate.instant('general.month.december'),
      ];

      textNoData = $translate.instant('reports.page.byprojects.nodata');
      textValue = $translate.instant('reports.page.sales.by.time.income');
      textCount = $translate.instant('reports.page.sales.by.time.count');
      textSqm = $translate.instant('reports.page.sales.by.time.sqm');
    });

    vm.metricsList = [
      { id: 'value', name: textValue },
      { id: 'count', name: textCount },
      { id: 'sqm', name: textSqm },
    ];

    function getYears(startYear) {
      var currentYear = new Date().getFullYear(),
        years = [];
      startYear = startYear || 2018;
      while (startYear <= currentYear) {
        years.push(startYear++);
      }
      return years;
    }

    vm.getData = function (year) {
      if (!requestInProgress) {
        requestInProgress = true;
        DashboardEmployeeSales.getData({ year: year }).$promise.then(
          function (response) {
            vm.noData = false;
            requestInProgress = false;
            vm.chartData = response;
            vm.mapForChart(response, vm.metric);
            vm.lastUpdatedAt = moment().format();
          },
          function (error) {
            vm.noData = true;
            requestInProgress = false;
          },
        );
      }
    };

    function getMetricValue(obj, metric) {
      var result = 0;

      switch (metric) {
        case 'sqm':
          result =
            parseFloat(obj['100_perc_area']) +
            parseFloat(obj['installments_area']);
          break;
        case 'count':
          result =
            parseInt(obj['100_perc_quantity']) +
            parseInt(obj['installments_quantity']);
          break;
        case 'value':
          result =
            parseFloat(obj['100_perc_income']) +
            parseFloat(obj['installments_income']);
          break;
      }

      switch (metric) {
        case 'sqm':
        case 'value':
          result = result.toFixed(2);
          break;
      }

      return result;
    }

    vm.mapForChart = function (arr, metric) {
      var data = [];
      var names = [''];
      var colors = [
        '#5793F3',
        '#DD4444',
        '#FEC42C',
        '#D4DF5A',
        '#66bb6a',
        '#5578C2',
        '#ab47bc',
        '#FD9C35',
        '#3949ab',
        '#e91e63',
        '#00bcd4',
        '#DD4D79',
        '#ffeb3b',
        '#8d6e63',
        '#BD3B47',
      ];

      var selectedColors = [''];

      if (vm.chartData.length === 0) {
        return false;
      }

      if (arr.length > 0) {
        arr.forEach(function (employee, employeeKey) {
          names.push(employee.name);

          if (employeeKey >= colors.length) {
            selectedColors.push(colors[employeeKey - 15]);
          } else {
            selectedColors.push(colors[employeeKey]);
          }

          if (employee.months.length) {
            var sortedMonths = employee.months.sort(function (a, b) {
              return a.month - b.month;
            });

            sortedMonths.forEach(function (employeeMonth, monthId) {
              if (data.length < employee.months.length) {
                data.push([]);
              }
              data[monthId][0] = textMonths[monthId];
              data[monthId][employeeKey + 1] = getMetricValue(
                employeeMonth,
                metric,
              );
            });
          }
        });
      } else {
        var toast = $mdToast
          .simple()
          .textContent(textNoData)
          .position('bottom right')
          .hideDelay(4000);
        $mdToast.show(toast).then(function () {});
        return false;
      }

      var template = [];
      $scope.height = 545;
      $scope.width = 900;
      template.push(names);
      template.push(selectedColors);
      $scope.dataSales = template.concat(data);
      $rootScope.$broadcast('chart.update');
    };
  }
})();
